import { ModalDirective } from 'ngx-bootstrap';
import { PioneerUtils } from './../../utils/pioneer-utils';
import { PaymentHttpService } from './../../service/payment.http.service';
import {
  Component,
  Input,
  OnInit,
  ViewChild
} from '@angular/core';
import { Payment } from '../../models/payment';
import { PaymentStatusUtils } from 'app/event/utils/payment-status-utils';
import { OnyxEvent } from 'app/event/models/event';
import { PaymentStatus } from '../../models/payment-status.enum';
import { PaymentStore } from '../../service/payment.store';

@Component({
  selector: 'pioneer-payment-record',
  templateUrl: './payment-record.component.html'
})
export class PaymentRecordComponent implements OnInit {

  static readonly FINAL_PAYMENT_COMMENTS_MAXLENGTH = 100;

  @Input()
  prepayment: Payment = null;

  @Input()
  event: OnyxEvent;

  @Input()
  finalPaymentStatusList: Payment[] = null;

  @ViewChild(ModalDirective)
  finalPaymentCommentsModal: ModalDirective;

  public config = {
    backdrop: 'static',
    keyboard: false
  };

  finalPaymentComments = '';

  constructor(private paymentStore: PaymentStore) {
  }


  ngOnInit(): void {
  }

  getPrepaymentClass() {
    return PaymentStatusUtils.isError(this.prepayment.status) ? 'text-danger font-weight-bold' : '';
  }

  getFinalPaymentStatusClass(status: PaymentStatus) {
    if (PaymentStatusUtils.isError(status)) {
      return 'text-danger font-weight-bold';
    } else {
      return '';
    }
  }

  displayFinalPaymentStatusList() {
    return !!this.finalPaymentStatusList && this.finalPaymentStatusList.length > 0;
  }

  resendPaymentRequest() {
    this.paymentStore.resendPaymentRequest(this.event.eventId)
      .take(1)
      .subscribe();
  }

  getFinalPaymentCommentsSubstring(finalPayment: Payment): string {
    const finalPaymentComments = this.getFinalPaymentComments(finalPayment);
    return PioneerUtils.safeSubstring(finalPaymentComments, 0, PaymentRecordComponent.FINAL_PAYMENT_COMMENTS_MAXLENGTH);
  }

  displayFinalPaymentCommentsMore(finalPayment: Payment): boolean {
    const finalPaymentComments = this.getFinalPaymentComments(finalPayment);
    return finalPaymentComments.length > PaymentRecordComponent.FINAL_PAYMENT_COMMENTS_MAXLENGTH;
  }

  getFinalPaymentComments(finalPayment: Payment): string {
    let finalPaymentComments: string;
    switch (finalPayment.status) {
      case PaymentStatus.READY:
        if (this.event.eventProperty.subscriber === true) {
          // Final payment comments from the hotel when the event is hotel-controlled.
          finalPaymentComments = finalPayment.description;
        } else {
          // When the event is agency-controlled and the hotel approves the payment request.
          finalPaymentComments = '';
        }
        break;
      case PaymentStatus.REQUESTED:
        // Final payment comments from the agency when payment is requested.
        finalPaymentComments = finalPayment.description;
        break;
      case PaymentStatus.PAID_DIRECT:
        // Final payment comments from the agency when payment is paid direct.
        finalPaymentComments = finalPayment.description;
        break;
      case PaymentStatus.CANCELLED:
        // Final payment comments from the agency when payment is cancelled.
        finalPaymentComments = finalPayment.description;
        break;
      case PaymentStatus.REQUEST_REJECTED:
        // Final payment comments from the hotel when payment request is rejected.
        finalPaymentComments = finalPayment.actionDetails;
        break;
      default:
        finalPaymentComments = '';
        break;
    }
    return finalPaymentComments;
  }

  isPaymentRejectedByHotel(finalPayment: Payment) {
    return finalPayment.status === PaymentStatus.REQUEST_REJECTED;
  }

  openFinalPaymentCommentsModal(finalPayment: Payment): void {
    this.finalPaymentComments = this.getFinalPaymentComments(finalPayment);
    this.finalPaymentCommentsModal.show();
  }

  closeFinalPaymentCommentsModal(): void {
    this.finalPaymentCommentsModal.hide();
    this.finalPaymentComments = '';
  }

  isSubrow(status: PaymentStatus) {
    return status === PaymentStatus.RESENT_REQUEST;
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/payment/payment-record/payment-record.component.ts